export default __webpack_public_path__ + "static/media/mode-55.1b1fb3d8.svg";